var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weike-info"},[_c('player',{attrs:{"data":_vm.weikeInfo}}),_c('question-venus')],1)}
var staticRenderFns = []

export { render, staticRenderFns }